"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var ShopContext_1 = require("./ShopContext");
var hooks_1 = require("preact/hooks");
var color_1 = require("../common/color");
var ShopSavePercentage = function () {
    var _a = (0, hooks_1.useContext)(ShopContext_1.default), colors = _a.colors, optionIndex = _a.optionIndex, options = _a.options, quantityIndex = _a.quantityIndex;
    var subscriptionSavingsPercentage = (0, hooks_1.useMemo)(function () {
        var _a, _b;
        var subscriptionPricing = (_a = options[optionIndex].purchaseTypes) === null || _a === void 0 ? void 0 : _a.references.nodes[0].products.references.nodes[quantityIndex].priceRange.minVariantPrice.amount;
        var oneTimeUnitPricing = (_b = options[optionIndex].purchaseTypes) === null || _b === void 0 ? void 0 : _b.references.nodes[1].products.references.nodes[0].priceRange.minVariantPrice.amount;
        if (!subscriptionPricing || !oneTimeUnitPricing) {
            return;
        }
        var oneTimePricing = +oneTimeUnitPricing * (quantityIndex + 1);
        return Math.round(((oneTimePricing - +subscriptionPricing) * 100) / oneTimePricing);
    }, [optionIndex, quantityIndex]);
    return ((0, preact_1.h)("p", { class: "shop-v2__percentage-description" },
        "Subscribe",
        ' ',
        (0, preact_1.h)("span", { class: "shop-v2__percentage", style: { backgroundColor: "".concat((0, color_1.toHex)(colors.freeShippingAlways)) } },
            "Save ",
            subscriptionSavingsPercentage,
            "%")));
};
exports.default = ShopSavePercentage;
